'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    if (this.props.inText) {
        theme.color = theme.inTextColor;
        theme.hoverColor = theme.inTextHoverColor;
        theme.hoverTextDecoration = theme.inTextHoverTextDecoration;
        theme.textDecoration = theme.inTextTextDecoration;
    }

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            fontSize: theme.fontSize,
            lineHeight: theme.lineHeight,
            fontFamily: theme.fontFamily,
            textDecoration: theme.textDecoration,
            color: theme.color,
            textAlign: theme.textAlign,
            transition: 'color ' + theme.transitionDuration + ' ' + theme.transitionFunction + ', text-decoration ' + theme.transitionDuration + ' ' + theme.transitionFunction,
            width: theme.width,
            minWidth: theme.minWidth,
            fontWeight: theme.fontWeight,

            '&:hover': {
                textDecoration: theme.hoverTextDecoration,
                color: theme.hoverColor,
                cursor: 'pointer'
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root)
    };
};

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _aphroditeJss = require('aphrodite-jss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseTheme = function baseTheme(theme) {
    var primary = (0, _color2.default)(theme.tAccent),
        hoverColor = void 0;

    hoverColor = primary.rotate(2);
    hoverColor = (0, _color2.default)(hoverColor).saturate(0.3);
    hoverColor = (0, _color2.default)(hoverColor).darken(0.2);
    hoverColor = hoverColor.rgb().string();

    return {
        fontSize: theme.tsNormal,
        lineHeight: theme.tlNormal,
        fontFamily: theme.fontFamily,
        textAlign: 'left',
        textDecoration: 'none',
        fontWeight: theme.twNormal,
        color: theme.tInactive,
        transitionFunction: theme.transitionFunction,
        transitionDuration: theme.transitionDuration,

        hoverTextDecoration: 'none',
        hoverColor: theme.tAccent,

        inTextColor: theme.tAccent,
        inTextTextDecoration: 'none',

        inTextHoverColor: hoverColor,
        inTextHoverTextDecoration: 'underline',
        width: 'auto',
        minWidth: 'auto'
    };
};